var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTl3AbtCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 269,
    viewBox: "0 0 233 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2507_8678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 107.902L116.5 81.3039L162.498 107.902L116.5 134.5L70.5024 107.902Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 107.902L116.5 81.3039L162.498 107.902L116.5 134.5L70.5024 107.902Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 107.902L116.5 134.5V187.697L70.5024 161.099V107.902Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 107.902L116.5 134.5V187.697L70.5024 161.099V107.902Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.497 107.902V161.099L116.5 187.697V134.5L162.497 107.902Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.497 107.902V161.099L116.5 187.697V134.5L162.497 107.902Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.498 147.799L185.496 121.201L231.493 147.799L185.496 174.398L139.498 147.799Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.498 147.799L185.496 121.201L231.493 147.799L185.496 174.398L139.498 147.799Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.498 147.799L185.496 174.398V227.594L139.498 200.996V147.799Z",
    fill: "#262828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.498 147.799L185.496 174.398V227.594L139.498 200.996V147.799Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.494 147.799V200.996L185.496 227.594V174.398L231.494 147.799Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.494 147.799V200.996L185.496 227.594V174.398L231.494 147.799Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50586 147.799L47.5032 121.201L93.5008 147.799L47.5032 174.398L1.50586 147.799Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50586 147.799L47.5032 121.201L93.5008 147.799L47.5032 174.398L1.50586 147.799Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50586 147.799L47.5032 174.398V227.594L1.50586 200.996V147.799Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50586 147.799L47.5032 174.398V227.594L1.50586 200.996V147.799Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5011 147.799V200.996L47.5034 227.594V174.398L93.5011 147.799Z",
    fill: "#262828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5011 147.799V200.996L47.5034 227.594V174.398L93.5011 147.799Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 187.697L116.5 161.099L162.498 187.697L116.5 214.295L70.5024 187.697Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 187.697L116.5 161.099L162.498 187.697L116.5 214.295L70.5024 187.697Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 187.697L116.5 214.295V267.492L70.5024 240.893V187.697Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 187.697L116.5 214.295V267.492L70.5024 240.893V187.697Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.497 187.697V240.893L116.5 267.492V214.295L162.497 187.697Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.497 187.697V240.893L116.5 267.492V214.295L162.497 187.697Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 28.1072L116.5 1.50889L162.498 28.1072L116.5 54.7056L70.5024 28.1072Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 28.1072L116.5 1.50889L162.498 28.1072L116.5 54.7056L70.5024 28.1072Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 28.1073L116.5 54.7056V107.902L70.5024 81.3039V28.1073Z",
    fill: "#262828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 28.1073L116.5 54.7056V107.902L70.5024 81.3039V28.1073Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.497 28.1073V81.3039L116.5 107.902V54.7056L162.497 28.1073Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.497 28.1073V81.3039L116.5 107.902V54.7056L162.497 28.1073Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.498 68.0047L185.496 41.4064L231.493 68.0047L185.496 94.6028L139.498 68.0047Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.498 68.0047L185.496 41.4064L231.493 68.0047L185.496 94.6028L139.498 68.0047Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.498 68.0048L185.496 94.6028V147.799L139.498 121.201V68.0048Z",
    fill: "#262828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.498 68.0048L185.496 94.6028V147.799L139.498 121.201V68.0048Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.494 68.0048V121.201L185.496 147.799V94.6028L231.494 68.0048Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.494 68.0048V121.201L185.496 147.799V94.6028L231.494 68.0048Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50586 68.0047L47.5032 41.4064L93.5008 68.0047L47.5032 94.6028L1.50586 68.0047Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50586 68.0047L47.5032 41.4064L93.5008 68.0047L47.5032 94.6028L1.50586 68.0047Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50586 68.0048L47.5032 94.6028V147.799L1.50586 121.201V68.0048Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50586 68.0048L47.5032 94.6028V147.799L1.50586 121.201V68.0048Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5011 68.0048V121.201L47.5034 147.799V94.6028L93.5011 68.0048Z",
    fill: "#262828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5011 68.0048V121.201L47.5034 147.799V94.6028L93.5011 68.0048Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 107.902L116.5 81.3039L162.498 107.902L116.5 134.5L70.5024 107.902Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 107.902L116.5 81.3039L162.498 107.902L116.5 134.5L70.5024 107.902Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 107.902L116.5 134.5V187.697L70.5024 161.099V107.902Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5024 107.902L116.5 134.5V187.697L70.5024 161.099V107.902Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.497 107.902V161.099L116.5 187.697V134.5L162.497 107.902Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.497 107.902V161.099L116.5 187.697V134.5L162.497 107.902Z",
    stroke: "#262828",
    strokeWidth: 1.26517,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2507_8678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 269,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTl3AbtCube);
export default __webpack_public_path__ + "static/media/tl3-abt-cube.78779bda1316a522a3e81bdfc8016356.svg";
export { ForwardRef as ReactComponent };